import React from 'react';
import './appInput.scss';

const AppInput = ({
  label,
  required,
  name,
  register = () => ({ onChange: () => {} }),
  errors = {},
  control = {},
  className = '',
  onChange: externalOnChange,
  ...rest
}) => {
  const { onChange: registeredOnChange, ...registerProps } = register(name);

  const handleChange = (e) => {
    e.target.value = e.target.value.replace(/^\s+/, '');
    registeredOnChange(e);
    if (externalOnChange) externalOnChange(e);
  };

  return (
    <div className={`input-container ${className}`}>
      <label htmlFor={name} className='input-label'>
        {label} {required && <span className='required'>*</span>}
      </label>
      <input
        className={`input-field ${errors[name] ? 'input-error' : ''}`}
        {...registerProps}
        {...rest}
        onChange={handleChange}
        autoComplete='autoCompleteStyle'
      />
      {errors[name] && <div className='error-message'>{errors[name]?.message || 'Invalid Value'}</div>}
    </div>
  );
};

export default AppInput;
